import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  CREATE_MESSAGE_SEGMENT_RESET,
  UPDATE_MESSAGE_SEGMENT_RESET,
} from "../../redux/constants/messageSegments";

import MessageSegmentsList from "./MessageSegmentsList";
import {
  deleteMessageSegment,
  getAllMessageSegments,
} from "../../redux/actions//messageSegmentSettings";
import MessageSegmentForm from "./MessageSegmentForm";
import Loader from "../Loader";
import Pagination from "../GroupInfo/Pagination";

const MessageSegments = ({ tab, openForm, setOpenForm,handleOpenForm }) => {
  const [selectedMessageSegment, setSelectedMessageSegment] = useState(null);
  const [curpage, setCurpage] = useState(1);

  const dispatch = useDispatch();

  const messageSegmentsSettings = useSelector(
    (state) => state.messageSegmentsSettings
  );
  const {
    loading,
    messageSegments,
    totalPage,
    successCreate,
    successDelete,
    successUpdate,
    messageSegmentCreate,
  } = messageSegmentsSettings;

  // console.log("curpage", curpage);

  const limit = 10;
  useEffect(() => {
    dispatch(getAllMessageSegments(limit * (parseInt(curpage) - 1), limit));
  }, [dispatch, curpage]);

  useEffect(() => {
    setCurpage(1);
  }, [tab]);

  useEffect(() => {
    if (successDelete) {
      dispatch(getAllMessageSegments(limit * (parseInt(curpage) - 1), limit));
    }
    if (successCreate) {
      setOpenForm(false);
      dispatch({
        type: CREATE_MESSAGE_SEGMENT_RESET,
      });
    }

    if (successUpdate) {
      setOpenForm(false);
      setSelectedMessageSegment(null);
      dispatch({
        type: UPDATE_MESSAGE_SEGMENT_RESET,
      });
    }
  }, [
    successDelete,
    successCreate,
    successUpdate,
    dispatch,
    curpage,
    messageSegmentCreate,
  ]);

  const handleRemoveMessageSegment = (id) => {
    dispatch(deleteMessageSegment(id));
  };

  return (
    <>
      {loading && <Loader />}
      {openForm && <div className="overlayMain activate"></div>}
      <MessageSegmentsList
        data={messageSegments}
        handleRemoveMessageSegment={handleRemoveMessageSegment}
        handleEditMessageSegment={(values) => {
          setSelectedMessageSegment(values);
          setOpenForm(true);
        }}
        handleOpenForm={handleOpenForm}
      />
       {messageSegments?.length > 0 && 
     
      <Pagination
        setCurpage={setCurpage}
        totalPage={totalPage}
        // page={page}
        page={curpage}
      />
       }
     
      {openForm && (
        <div id="tab-4" className="tab-content">
          <MessageSegmentForm
            selectedMessageSegment={selectedMessageSegment}
            setOpenForm={(val) => {
              setSelectedMessageSegment(null);
              setOpenForm(val);
            }}
          />
        </div>
      )}
    </>
  );
};

export default MessageSegments;
